import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TrackCardController } from '../track-card.controller';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { KexpMiniTrackInfoComponent } from '../../track-info/mini-track-info.component';

@Component({
  selector: 'mini-track-card',
  templateUrl: './mini-track-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FaIconComponent,
    KexpMiniTrackInfoComponent
  ]
})
export class MiniTrackCardComponent extends TrackCardController {

  protected readonly faChevronRight = faChevronRight;

  constructor() {
    super();
    this.useThumbnail = true;
  }

}
